import * as React from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { ConfirmationModal } from './ConfirmationModal';
import { CheckboxTooltip } from './Tooltip';
import { axios } from '../api';
import { useGetCustomer } from '../hooks/getCustomer';
import { BOTTOM_TOAST, generateErrorMsg } from '../utils';

interface OptInSMSProps {
  customerId: string;
}

export const OptInSMS = ({ customerId }: OptInSMSProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { customer, refreshCustomer } = useGetCustomer(customerId);

  const isOptedIn = customer?.proactive_customer_support_opted_in;
  const optDirection = !isOptedIn ? 'in to' : 'out of';

  const handleOptChangeConfirmed = () => {
    setShowConfirmModal(false);

    axios
      .put(`/accounts/${customer.id}/update_proactive_customer_support/`, {
        proactive_customer_support_opted_in: !isOptedIn,
      })
      .then(async () => {
        await refreshCustomer();
        toast.success('Proactive CX outreach setting successfully updated', BOTTOM_TOAST);
      })
      .catch((e) => {
        toast.error(generateErrorMsg(e), BOTTOM_TOAST);
      });
  };

  return (
    <a className="checkbox-tooltip-anchor">
      <div className="flex justify-between items-center">
        <CheckboxTooltip
          isChecked={!!isOptedIn}
          onChange={(isChecked) => {
            if (isChecked !== isOptedIn) {
              setShowConfirmModal(true);
            }
          }}
          text={`Customer is opted ${isOptedIn ? 'in to' : 'out of'} proactive CX outreach`}
        />

        {showConfirmModal && (
          <ConfirmationModal
            title={`Are you sure you want to opt this customer ${optDirection} proactive CX outreach?`}
            customMessage={
              <p className="text-sm mb-4 text-center text-black-600">
                {`By proceeding, you will opt this customer ${optDirection} future CX outreach campaigns conducted over phone/SMS.`}
              </p>
            }
            confirmLabel="Confirm"
            onConfirm={handleOptChangeConfirmed}
            onCancel={() => {
              setShowConfirmModal(false);
            }}
          />
        )}
      </div>
    </a>
  );
};
